import type { Goal } from "@medplum/fhirtypes";
import { GOAL_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useGoalSubscription = createSubscriptionHook<Goal>("Goal", GOAL_COLLECTION_NAME);
